module.exports = __webpack_public_path__ + "img/PARTE_CENTRIF_CARROS.98200728.jpg";